<!--
  LoadingOverlay.svelte — Full-area spinner overlay.

  Covers its parent container with a semi-transparent backdrop and
  a centered spinner.  Used for page-level or card-level loading states.

  @prop {boolean} [show]  — Whether the overlay is visible. Default: true.
  @prop {string}  [label] — Accessible label for the spinner.
-->
<script lang="ts">
	import { Spinner } from 'flowbite-svelte';
	import { t } from '../i18n';

	
	
	interface Props {
		/** Whether the overlay and spinner are displayed. */
		show?: boolean;
		/** Accessible label describing what is loading. */
		label?: string;
	}

	let { show = true, label }: Props = $props();
</script>

{#if show}
	<div
		class="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/60 dark:bg-zinc-900/60"
		aria-label={label ?? $t('Loading…')}
	>
		<Spinner size="8" />
	</div>
{/if}
